'use strict';

var _taxonomy = require('../../taxonomy');

var _taxonomy2 = _interopRequireDefault(_taxonomy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classifications = _taxonomy2.default.classifications;

var classificationLabelsById = {};

var indexClassification = function indexClassification(classification) {
  classificationLabelsById[classification.id] = classification.description;
};

classifications.forEach(function (classification) {
  indexClassification(classification);
  classification.subClassifications.forEach(function (subClass) {
    indexClassification(subClass);
  });
});

var getClassificationLabelById = function getClassificationLabelById(id) {
  return classificationLabelsById[id];
};

var getSummaryForIds = function getSummaryForIds(ids, itemNames) {
  if (ids.length === 0) {
    return '';
  }

  return ids.length === 1 ? getClassificationLabelById(ids[0]) : ids.length + ' ' + itemNames;
};

var getClassSummary = function getClassSummary(query) {
  var classification = query.classification;
  var subclassification = query.subclassification;

  var classificationIds = classification ? classification.split(',') : [];
  var subclassificationIds = subclassification ? subclassification.split(',') : [];

  if (classificationIds.length <= 1 && subclassificationIds.length === 1) {
    return getSummaryForIds(subclassificationIds, 'Sub-Classifications');
  }

  return getSummaryForIds(classificationIds, 'Classifications');
};

var titleCase = function titleCase(string) {
  return string.split(' ').map(function (part) {
    return part && part[0].toUpperCase() + part.slice(1);
  }).join(' ');
};

module.exports = function (query, locale) {
  var keywords = query.keywords;
  var keywordSummary = keywords ? titleCase(keywords) : 'Jobs';

  var classSummary = keywords ? '' : getClassSummary(query);

  var what = keywordSummary + (classSummary ? ' in ' + classSummary : '');
  var where = query.where || (/^nz$/i.test(locale) ? 'NZ' : 'Australia');

  return what + ' in ' + where;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/lib/last-search-cookie/summary.js
 ** module id = 462
 ** module chunks = 0
 **/